<ix-card
  (click)="openLink()"
  class="h-100 w-100"
  onkeypress=""
  variant="neutral"
>
  <ix-card-content
    class="topic-card-content"
    style.backgroundColor="var({{ color }})"
  >
    <ix-typography
      [title]="heading"
      bold="true"
      class="ellipsis"
      format="body-lg"
    >{{ heading }}
    </ix-typography
    >
    <hr/>
    <ix-typography [title]="subheading" class="ellipsis" format="body-lg">{{
        subheading
      }}
    </ix-typography>
    <ix-icon [name]="icon" size="32" class="mt-auto"></ix-icon>
  </ix-card-content>
</ix-card>
